import navigateToDashboardProcessing from './views/document/utils/navigateToDashboardProcessing';

export default class ErrorHandling {
  static init() {
    window.addEventListener('error', (event) => {
      if (event.message.includes('Uncaught CKEditorError: cloudservices-init')) {
        ErrorHandling.handleCKEditorCloudInitError();
      }
    });
  }

  static handleCKEditorCloudInitError() {
    navigateToDashboardProcessing();
  }
}
